module.exports = __webpack_public_path__ + "static/assets/c75a0d88ebc0f52ca9de5689c102d937.svg";